  const GlobalHeader = ({onIconClick} ) => {
    return (
    <header class="slds-global-header_container">
    <a href="#" class="slds-assistive-text slds-assistive-text_focus">Skip to Navigation</a>
    <a href="#" class="slds-assistive-text slds-assistive-text_focus">Skip to Main Content</a>
    <div class="slds-global-header slds-grid slds-grid_align-spread">
      <div class="slds-global-header__item">
        <div class="slds-global-header__logo">
          <span class="slds-assistive-text">Salesforce</span>
        </div>
      </div>
      <div class="slds-global-header__item slds-global-header__item_search">
        <button type="button" class="slds-button slds-button_neutral slds-truncate">
          <span class="slds-icon_container slds-button__icon_left slds-icon-utility-search">
              <svg class="slds-icon slds-icon slds-icon_xx-small slds-icon-text-default" aria-hidden="true">
                <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#search"></use>
              </svg>
          </span>
          Search...
        </button>
      </div>
      <div class="slds-global-header__item">
        <ul class="slds-global-actions">
          <li class="slds-global-actions__item">
            <div class="slds-global-actions__favorites slds-dropdown-trigger slds-dropdown-trigger_click">
              <div class="slds-button-group">
                <button
                  class="slds-button slds-button_icon slds-global-actions__favorites-action slds-button_icon slds-button_icon-border slds-button_icon-small"
                  aria-pressed="false"
                  title="Toggle Favorites"
                >
                  <span class="slds-icon_container slds-icon-utility-favorite">
                    <svg class="slds-icon slds-icon slds-icon_xx-small slds-icon-text-default" aria-hidden="true">
                      <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#favorite"></use>
                    </svg>
                </span>
                </button>
                <button
                  class="slds-button slds-button_icon slds-global-actions__favorites-more slds-button_icon slds-button_icon-border slds-button_icon-small"
                  title="View Favorites"
                >
                  <span class="slds-icon_container slds-icon-utility-down">
                    <svg class="slds-icon slds-icon slds-icon_xx-small slds-icon-text-default" aria-hidden="true">
                      <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#down"></use>
                    </svg>
                </span>
                </button>
              </div>
            </div>
          </li>
          <li class="slds-global-actions__item">
            <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
              <button
                class="slds-button slds-button_icon slds-button_icon slds-button_icon-container slds-button_icon-small slds-global-actions__task slds-global-actions__item-action"
                aria-haspopup="true"
                title="Global Actions"
              >
                <span class="slds-icon_container slds-icon-utility-add">
                    <svg class="slds-icon slds-icon slds-icon_xx-small slds-icon-text-default" aria-hidden="true">
                      <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#add"></use>
                    </svg>
                </span>
              </button>
            </div>
          </li>
          <li class="slds-global-actions__item slds-global-actions__item_help">
            <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
              <button
                class="slds-button slds-button_icon slds-button_icon slds-button_icon-container slds-button_icon-small slds-global-actions__help slds-global-actions__item-action"
                aria-haspopup="true"
                title="Help and Training"
              >
                <span class="slds-icon_container slds-icon-utility-question">
                    <svg class="slds-icon slds-icon slds-icon_xx-small slds-icon-text-default" aria-hidden="true">
                      <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#question"></use>
                    </svg>
                </span>
              </button>
            </div>
          </li>
          <li class="slds-global-actions__item">
            <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
              <button
                class="slds-button slds-button_icon slds-button_icon slds-button_icon-container slds-button_icon-small slds-global-actions__setup slds-global-actions__item-action"
                aria-haspopup="true"
                title="Setup"
              >
                <span class="slds-icon_container slds-icon-utility-setup">
                    <svg class="slds-icon slds-icon slds-icon_xx-small slds-icon-text-default" aria-hidden="true">
                      <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#setup"></use>
                    </svg>
                </span>
              </button>
            </div>
          </li>
          <li class="slds-global-actions__item slds-global-actions__item_notification">
            <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
              <button
                class="slds-button slds-button_icon slds-button_icon slds-button_icon-container slds-button_icon-small slds-global-actions__notifications slds-global-actions__item-action"
                title="no new notifications"
                aria-live="assertive"
                aria-atomic="true"
              >
                
                <span class="slds-icon_container slds-icon-utility-notification">
                    <svg class="slds-icon slds-icon slds-icon_xx-small slds-icon-text-default" aria-hidden="true">
                      <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#notification"></use>
                    </svg>
                </span>
              </button>
              <span aria-hidden="true" class="slds-notification-badge">0</span>
            </div>
          </li>
          <li class="slds-global-actions__item">
            <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
              <button
                class="slds-button slds-global-actions__avatar slds-global-actions__item-action"
                title="person name"
                aria-haspopup="true"
                onClick={() => onIconClick("true")}
              >
                <span class="slds-avatar slds-avatar_circle slds-avatar_medium">
                  <img alt="Theming Agent AI" src="/icons/utility/einstein_alt_120.png" title="Theming Agent" />
                </span>
              </button>
            </div>
          </li>
          <li class="slds-global-actions__item">
            <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
              <button
                class="slds-button slds-global-actions__avatar slds-global-actions__item-action"
                title="person name"
                aria-haspopup="true"
              >
                <span class="slds-avatar slds-avatar_circle slds-avatar_medium">
                  <img alt="Person name" src="/images/avatar1.jpg" title="User avatar" />
                </span>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </header>
    )
  }
export default GlobalHeader;